// removed by extract-text-webpack-plugin
module.exports = {"content":"AdminSettings__content__cGG-F","buttons":"AdminSettings__buttons__9zs01"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AdminSettings/AdminSettings.css
// module id = 1860
// module chunks = 0